module.exports = __webpack_public_path__ + "img/kpdf-3.c38bbc09.jpg";